export default ['conflict', 'extra_cost'];
